
import { Component, Vue } from 'vue-property-decorator'
import TitlePage from '@/components/atoms/TitlePage.vue'
import HtmlContent from '@/components/molecules/HtmlContent.vue'
import HtmlEditor from '@/components/organisms/HtmlEditor.vue'

/**
 * HTMLエディタ用デバッグ画面
 */
@Component({
  components: {
    TitlePage,
    HtmlContent,
    HtmlEditor,
  },
})
export default class DebugEditor extends Vue {
  /** 題名 */
  private title = ''

  /** htmlデータ */
  private html = ''

  /** 表示切り替え：編集 */
  private modeEdit = true

  /** 表示切り替え：表示 */
  private modePreview = false

  /** 表示切り替え：ソース取得 */
  private modeSource = false

  /**
   * 編集モードに切り替え
   */
  private changeModeEdit(): void {
    this.modeEdit = true
    this.modePreview = false
    this.modeSource = false
  }

  /**
   * 表示モードに切り替え
   */
  private changeModePreview(): void {
    this.modeEdit = false
    this.modePreview = true
    this.modeSource = false
  }

  /**
   * ソース取得モードに切り替え
   */
  private changeModeSource(): void {
    this.modeEdit = false
    this.modePreview = false
    this.modeSource = true
  }
}
